// When an email on a weekly pattern next goes: the first chosen day, at its time, after `now`.
// `days` count from Monday (0) to Sunday (6), as the Before Service settings and schedules
// keep them; `hhmm` is the venue's wall clock, which for the back office is the browser's.
export function nextSend(days, hhmm, now = new Date()) {
  if (!days?.length || !/^\d{1,2}:\d{2}$/.test(hhmm || '')) return null;
  const [h, m] = hhmm.split(':').map(Number);
  for (let i = 0; i <= 7; i += 1) {
    const at = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, h, m);
    if (days.includes((at.getDay() + 6) % 7) && at > now) return at;
  }
  return null;
}

// "Thursday 22 Oct at 08:00"
export function sendWords(at) {
  if (!at) return '';
  const day = at.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' }).replace(',', '');
  const time = `${String(at.getHours()).padStart(2, '0')}:${String(at.getMinutes()).padStart(2, '0')}`;
  return `${day} at ${time}`;
}
